import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumenes" className="defer-paint w-full scroll-mt-6 bg-ink py-12 sm:py-14" aria-labelledby="volumes-heading" data-id="element-182" data-mp="cm526r4zghlj">
      <div className="mx-auto max-w-4xl px-6" data-id="element-183" data-mp="3g4py6yqp1cy6">
        <SectionHeading eyebrow="El sistema completo" title={<span id="volumes-heading" data-id="element-185" data-mp="3c461txdy2dd3">
              El sistema completo que resuelve todo esto
            </span>} lead="6 volúmenes de entrenamiento técnico + 5 bonos exclusivos. Abrí cualquier volumen para ver qué incluye." data-id="element-184" data-mp="3g5hiveir5q9o" />

        <ol className="mt-9 space-y-2.5" data-id="element-186" data-mp="3l3j1xzg6hpl5">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-coal transition-colors duration-150 ease-out ${isOpen ? 'border-gold/45' : 'border-line'}`} data-id="element-187" data-mp="2xcdlpj6bsvab" data-mpi={index}>
                <h3 data-id="element-188" data-mp="29epb61pb5wrd">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:px-6" data-id="element-189" data-mp="29debacyzh95j">
                    <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border font-display text-base font-bold transition-colors duration-150 ease-out ${isOpen ? 'border-gold bg-gold text-ink' : 'border-gold/35 bg-gold/10 text-gold'}`} aria-hidden="true" data-id="element-190" data-mp="1qh5zsrfdo21s">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-191" data-mp="24eb34jnpimtc">
                      <span className="block font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone" data-id="element-192" data-mp="3bur1ekks2e5g">
                        Volumen {index + 1}
                      </span>
                      <span className="mt-1 block font-display text-lg font-bold leading-snug text-ivory sm:text-xl" data-id="element-193" data-mp="1gq1bwel4vkmw">
                        {volume.name}
                      </span>
                      <span className="mt-1 block font-sans text-[11px] uppercase tracking-[0.14em] text-gold" data-id="element-194" data-mp="1ps0vnenj92tj">
                        {volume.count}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-195" data-mp="x2btgxz36wqc" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-196" data-mp="16toi7gpl96s5">
                  <div className="overflow-hidden" data-id="element-197" data-mp="eb13cj16qnzi">
                    <div className="border-t border-line px-5 py-5 sm:px-6" data-id="element-198" data-mp="9d94t661c3mc">
                      <p className="font-sans text-[0.9rem] leading-relaxed text-stone" data-id="element-199" data-mp="9b6dmit5c4g1">
                        {volume.intro}
                      </p>

                      <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-200" data-mp="2pscpqh21i3dw">
                        <div className="rounded-2xl bg-graphite p-4" data-id="element-201" data-mp="2c06bj0ig66h3">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-track-light" data-id="element-202" data-mp="2bxtm62ad0tu0">
                            ¿Qué resuelve?
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-ivory/85" data-id="element-203" data-mp="34mh8m16uhp95">
                            {volume.solves}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-gold/25 bg-gold/[0.07] p-4" data-id="element-204" data-mp="2uss1x5al54ua">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-205" data-mp="2zrle8ue4ypsv">
                            Resultado
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-ivory/85" data-id="element-206" data-mp="1obn22hnnvnnf">
                            {volume.result}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}